/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

export const APP_ROUTES = {
  notFound: 'not-found',
  homePage: 'home-page',
  auth: {
    login: 'auth.login',
    otp: 'auth.loginOtp',
    register: 'auth.register',
    forgotPassword: 'auth.forgotPassword',
    logout: 'logout'
  },
  public: {
    aboutUs: 'aboutUs',
    contactUs: 'contactUs',
    privacyPolicy: 'privacyPolicy',
    termsAndConditions: 'termsAndConditions',
    apply: 'apply'
  },
  user: {
    home: 'panel.user.home',
    profile: 'panel.user.profile',
    index: 'panel.user.index',
    notifications: 'panel.notification.index'
  },
  order: {
    index: 'panel.sales.order.index',
    show: 'panel.sales.order.show-order'
  },
  reports: {
    orderNotes: 'panel.reports.order_notes'
  }
}
